import React from 'react'
import { Link } from 'gatsby'
import logo from '../img/logo-white.svg'

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="is-centered has-text-centered has-background-primary p-b-md has-text-black p-t-md ">
          <div className="container m-t-md m-b-md">
            <div className="columns">
              <div className="column is-2 m-b-auto m-t-auto">
                <div className="has-text-centered">
                  <Link to="/">
                    <img src={logo} alt="Embarca" style={{ width: '100%', maxWidth: '150px' }} />
                  </Link>
                </div>
              </div>
              <div className="column is-2 m-b-auto m-t-auto has-text-centered">
                <Link className="has-text-white" to="/about"> Sobre Nosotros </Link>
              </div>
              <div className="column is-1 m-b-auto m-t-auto has-text-centered">
                <Link className="has-text-white" to="/blog"> Últimas Notas </Link>
              </div>
              <div className="column is-2 m-b-auto m-t-auto has-text-centered">
                <a className="has-text-white" href="https://embarca.tech/" target="_blank" rel="noopener noreferrer"> Landing </a>
              </div>
              <div className="column is-1 m-b-auto m-t-auto has-text-centered">
                <a className="has-text-white" href="/admin/" target="_blank" rel="noopener noreferrer"> Admin </a>
              </div>
              <div className="column is-4 social has-text-centered m-b-auto m-t-auto">
                <a title="facebook" href="https://www.facebook.com/aceleradoraembarca/">
                  <i className="fab fa-facebook"></i>
                </a>
                <a title="Telefono" href="https://twitter.com/EmbarcaMza">
                  <i className="fab fa-twitter"></i>
                </a>
                <a title="instagram" href="https://www.instagram.com/embarcamza/">
                  <i className="fab fa-instagram"></i>
                </a>
                <a title="Whatsapp" href="https://api.whatsapp.com/send?phone=542614182839&text=Hola%20Embarca!">
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
        </div>
        <div className="columns is-vcentered is-centered m-none p-none">
          <div className="column m-none p-none">
            <div className="has-text-centered has-text-white">
              <p className="p-none m-none fa-1x" style={{"justifyContent":"Center","display":"flex"}}>
                <svg height="20" className="octicon octicon-code m-r-xs is-vcentered" aria-label="code" fill="currentColor"
                viewBox="0 0 14 16" version="1.1" width="17" role="img">
                <path d="M9.5 3L8 4.5 11.5 8 8 11.5 9.5 13 14 8 9.5 3zm-5 0L0 8l4.5 5L6 11.5 2.5 8 6 4.5 4.5 3z"></path>
              </svg> with <span className="heart">♥</span> by <a className="m-l-xs has-text-white text-warning"
                  href="https://frani.me" rel="noopener noreferrer" target="_blank">  Frani</a></p>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
